export const sliceKey = 'catalogueContent';
